import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0010',
    ecrans: ['00-2'],
    params: ['id',
             'niveau']
});
